export const GOVERNORATES = [
  { id: 11, displayName: "Ibb | اب" ,shortCut: "Ibb"},
  { id: 12, displayName: "Abyan | ابين" ,shortCut:"Abyan"},
  { id: 13, displayName: "Sana'a City | امانة العاصمه",shortCut:"Sana'a City" },
  { id: 14, displayName: "Al Bayda | البيضاء" ,shortCut:"Al Bayda"},
  { id: 15, displayName: "Ta'iz | تعز" ,shortCut:"Ta'iz"},
  { id: 16, displayName: "Al Jawf | الجوف" ,shortCut:"Al Jawf"},
  { id: 17, displayName: "Hajjah | حجه" ,shortCut:"Hajjah"},
  { id: 18, displayName: "Al Hodeidah | الحديده" ,shortCut:"Al Hodeidah"},
  { id: 19, displayName: "Hadramawt | حضرموت" ,shortCut:"Hadramawt"},
  { id: 20, displayName: "Dhamar | ذمار" ,shortCut:"Dhamar"},
  { id: 21, displayName: "Shabwah | شبوه" ,shortCut:"Shabwah"},
  { id: 22, displayName: "Sa'dah | صعده" ,shortCut:"Sa'dah"},
  { id: 23, displayName: "Sana'a | صنعاء" ,shortCut:"Sana'a"},
  { id: 24, displayName: "Aden | عدن" ,shortCut:"Aden"},
  { id: 25, displayName: "Lahj | لحج" ,shortCut:"Lahj"},
  { id: 26, displayName: "Ma'rib | مارب" ,shortCut:"Ma'rib"},
  { id: 27, displayName: "Al Mahwit | المحويت" ,shortCut:"Al Mahwit"},
  { id: 28, displayName: "Al Maharah | المهره" ,shortCut:"Al Maharah"},
  { id: 29, displayName: "Amran | عمران" ,shortCut:"Amran"},
  { id: 30, displayName: "Ad Dali' | الضالع" ,shortCut:"Ad Dali"},
  { id: 31, displayName: "Raymah | ریمه" ,shortCut:"Raymah"},
  { id: 32, displayName: "Socotra | سقطرى" ,shortCut:"Socotra"}
];